export default {
  name: 'en',
  epx: {
    common: {
      sure: 'sure',
      cancel: 'cancel',
      selectPlaceholder: 'Please search or select',
      noData: 'No Data',
    },
    tablePage: {
      totalPageSize: '{totalPageSize} pages in total',
      total: '{total} records in total',
    },
    tableDialog: {
      selectedField: 'selected field',
    },
    collapse: {
      openText: 'expand',
      closeText: 'collapse',
    },
    case: {
      title: 'en-title',
    },
    editor: {
      link: 'link',
      linkPlaceholder: 'paste or enter a link',
      target: 'new window opens',
      add: 'add',
      uploadPicture: 'upload pictures',
      onlinePicture: 'internet pictures',
      pictureAddress: 'image URL',
      pictureDescription: 'image description',
      insert: 'insert',
      uploadVideo: 'upload video',
      onlineVideo: 'online video',
      videoAddress: 'video URL',
      videoWidth: 'video width',
      small: 'small',
      middel: 'middle',
      large: 'large',
      boldTip: 'bold',
      italicTip: 'italic',
      bulletTip: 'bullet',
      orderedTip: 'ordered',
      blockquoteTip: 'blockquote',
      codeTip: 'code',
      strikeTip: 'strike',
      undoTip: 'undo',
      redoTip: 'redo',
      emojiTip: 'emoji',
      underlineTip: 'underline',
      horizontalTip: 'horizontal',
      alignLeftTip: 'alignLeft',
      alignRightTip: 'alignRight',
      alignCenterTip: 'alignCenter',
      alignJustifyTip: 'alignJustify',
      imageTip: 'image',
      videoTip: 'video',
      linkTip: 'link',
      headingTip: 'heading',
      fontSizeTip: 'fontSize',
    },
    virtualList: {
      loadingText: 'Loading...',
      errorText: 'Request failed',
      finishedText: 'No more',
    },
    emoji: {
      weixinEmoji: 'WeiXin Emoji',
      commonEmoji: 'Common Emoji',
    },
    loadMore: {
      moreText: 'Rolling load',
      loadingText: 'Loading...',
      errorText: 'Request failed',
      noMoreText: 'No more',
    },
    tabsSelect: {
      searchPlaceholder: 'Search by keyword',
      loading: 'Loading...',
      searchEmptyText: 'No search results yet',
    },
  },
}
